import { ConsumptionCsvGroupBy } from "@shared/services/usage-explorer/fetchConsumptionCsv.ts";
import {
  TourConsumptionMonth,
  TourConsumptionRow,
} from "@shared/types/localTypes/tour.ts";
import sortTourConsumptionRows from "@shared/services/tour/mockedApis/usageExplorer/sort-tour-consumption-rows.ts";

type AggregateTourConsumptionPeriod = (args: {
  readonly months: ReadonlyArray<TourConsumptionMonth>;
  readonly groupBy: ConsumptionCsvGroupBy;
}) => ReadonlyArray<TourConsumptionRow>;

const aggregateTourConsumptionPeriod: AggregateTourConsumptionPeriod = ({
  months,
  groupBy,
}) => {
  const totals = new Map<string, TourConsumptionRow>();
  for (const row of months.flatMap((month) => month.rows[groupBy] ?? [])) {
    const key = `${row.jpd}/${row.name}`;
    const current = totals.get(key);
    totals.set(key, {
      jpd: row.jpd,
      name: row.name,
      trafficBytes: (current?.trafficBytes ?? 0) + row.trafficBytes,
      storageBytes: Math.max(current?.storageBytes ?? 0, row.storageBytes),
    });
  }

  return sortTourConsumptionRows([...totals.values()]);
};

export default aggregateTourConsumptionPeriod;
